import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import PageHero from '../components/PageHero';
import { fetchLeads } from '../api';
import { Mail, Phone, RefreshCw } from 'lucide-react';

const LeadsAdminPage = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchLeads();
      setLeads(data);
    } catch (e) {
      setError('Could not fetch leads');
    } finally {
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/set-state-in-effect
  useEffect(() => { load(); }, []);

  return (
    <Layout>
      <PageHero title="Leads Dashboard" subtitle="All form submissions captured from the website." breadcrumb="Admin" />

      <section className="py-16 bg-[#F7F7F5] min-h-[60vh]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-[#2C5F66] text-2xl font-bold">{leads.length} Lead{leads.length === 1 ? '' : 's'}</h2>
              <p className="text-gray-500 text-sm">Most recent first</p>
            </div>
            <button onClick={load} className="inline-flex items-center gap-2 bg-[#2C5F66] hover:bg-[#244e54] text-white px-5 py-2.5 rounded-md text-sm font-medium transition-colors">
              <RefreshCw size={14} /> Refresh
            </button>
          </div>

          {loading && <p className="text-gray-500">Loading…</p>}
          {error && <p className="text-red-600">{error}</p>}
          {!loading && leads.length === 0 && !error && <p className="text-gray-500 bg-white p-8 rounded-lg text-center">No leads yet. Submissions will appear here.</p>}

          <div className="grid gap-4">
            {leads.map((lead) => (
              <div key={lead.id} className="bg-white rounded-lg shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow">
                <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
                  <div>
                    <div className="flex items-center gap-3 mb-2">
                      <h3 className="text-[#2C5F66] font-bold text-lg">{lead.name}</h3>
                      <span className="text-xs bg-[#D9A04A]/15 text-[#B17A24] px-2 py-0.5 rounded-full font-semibold">{lead.service}</span>
                    </div>
                    <div className="flex flex-wrap gap-x-5 gap-y-1 text-sm text-gray-600">
                      <span className="inline-flex items-center gap-1"><Mail size={14} /> {lead.email}</span>
                      {lead.phone && <span className="inline-flex items-center gap-1"><Phone size={14} /> {lead.phone}</span>}
                    </div>
                    {lead.message && <p className="mt-3 text-gray-700 text-sm leading-relaxed">{lead.message}</p>}
                  </div>
                  <div className="text-right text-xs text-gray-400 flex-shrink-0">
                    <div>{new Date(lead.created_at).toLocaleString()}</div>
                    <div className="mt-1">via {lead.source}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default LeadsAdminPage;
